import { render, staticRenderFns } from "./TaxTmModal.vue?vue&type=template&id=32e2bb48"
import script from "./TaxTmModal.vue?vue&type=script&lang=js"
export * from "./TaxTmModal.vue?vue&type=script&lang=js"
import style0 from "./TaxTmModal.vue?vue&type=style&index=0&id=32e2bb48&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports